export class RequiredCryptoError extends Error {
    constructor() {
        super('Crypto is required!');
    }
}
